import { Teacher } from '@/pages/api/teachers/types';
interface Review {
  text: string;
  author?: {
    name?: string;
    profession?: string;
  };
}
export interface Host extends Omit<Teacher, 'isVisibleOnPaymentPage'> {
  reviews: Array<Review>;
}
export const SPEAKING_CLUB_HOSTS: Array<Host> = [{
  name: 'Ian',
  surname: '',
  patronymicName: '',
  taxNumber: '',
  tel: '',
  id: '',
  img: '/images/teachers/ian.webp',
  facts: ['Носитель языка с опытом преподавания 33 года', 'Преподает Business English, HR management English и General English', 'Имеет опыт работы интервьюером в англоязычных компаниях', 'Преподавал в крупных Европейских и Российских вузах'],
  reviews: [{
    text: 'Занятие прошло отлично, все понравилось. много говорили, Йэн поправлял по ходу, подсказывал уместные выражения. После отправил дополнительные материалы по подготовке презентаций В целом диалог строится очень легко, тк Йэн подходит к занятиям ответственно и доброжелательно',
    author: {
      name: 'Юрий',
      profession: 'Маркетолог'
    }
  }, {
    text: 'Я посетила английский разговорный клуб, где хостом был Иен, носитель языка. Иен создал дружелюбную атмосферу, где мы свободно общались на английском. Он делился интересными историями, помогал с произношением и даже подсказывал нам фразы, которые носители часто используют. Приду еще!',
    author: {
      name: 'Ирина'
    }
  }, {
    text: 'Thanks a million, Ian! It was a pleasure to meet you and finally practice English with the native I feel like this is what I’ve been missing lately',
    author: {
      name: 'Анна'
    }
  }, {
    text: 'Привет) очень понравилось на спикинге) дружелюбная атмосфера, юмор, английский) все как я люблю) спасибо большое за controversial темы, их очень хочется обсудить, просто молча посидеть не получится, потому что пока слушаешь других, у тебя появляются интересные мысли, которыми не можешь не поделиться с другими)',
    author: {
      name: 'Аделя'
    }
  }]
}, {
  name: 'Анна',
  surname: '',
  patronymicName: '',
  taxNumber: '',
  tel: '',
  id: '',
  img: '/images/teachers/anna.webp',
  facts: ['Опыт работы со взрослыми 6 лет', 'Говорю на 5 языках: русский, английский, арабский, персидский и японский', 'Помогаю в составлении резюме и сопроводительного письма', 'Жила в Европе, общаясь только с носителями языка'],
  reviews: [{
    text: 'Очень понравилась атмосфера и легкость, что ли. Слова забывались, где-то что-то криво говорилось, но основной целью кажется было - разговаривать и no matter what) Темп и плотность разговора также была такая, что захочешь отвлечься - не успеешь. Это здорово. Разговорной практики мне хватило, я беспокоюсь, только, что я иногда сильно увлекалась и слишком много болтала. Глобально мне очень понравился формат, тема и структура. Дальше подсвечу некоторые моменты, но это скорее детали и какие-то акценты что ли, куда можно подумать: 1,5 часа для меня с непривычки как будто было многовато, после часа уже поняла, что устала. Иногда не совсем было понятно, что конкретно надо обсудить в парах, особенно к концу) поэтому обсуждали, что поняли))) почти всегда попадали, но иногда не точно. Но опять же так как цель была разговаривать - кажется не так уж критично. Еще один пункт, про что я думаю (это скорее моя рефлексия, но может вам тоже будет полезно). Когда немного разговорюсь - ставить какие-то задачи на каждое занятие, типа использовать вот такие слова, следить за применением вводных консрукций и тд. Чтобы какая-то более последовательная прокачка что ли была. и спасибо большое, вы - чудесная!',
    author: {
      name: 'Daria',
      profession: 'Маркетолог'
    }
  }, {
    text: 'I think, these speaking clubs perfectly complete my english classes, it gives me opportunity to discuss actual topics, to exchange opinions and different points of view with other colleague from Tech-industry',
    author: {
      name: 'Maria',
      profession: 'HR Manager'
    }
  }, {
    text: "Yes, sure. I enjoyed the meeting, the topic was really useful, all of information was new for me, because I almost don't use linkedIn. I think, I didn't have enough speaking practice, but it because of me. I am too shy, I have a small vocabulary and also I don't really interesting in conversation, because there is not my friends, but new people. Sometimes I felt an awkward pause, but I don't know how to make it better in this format. Anyway, it is good practice for my soft skills and thank you for preparing such useful meeting! :)",
    author: {
      name: 'Tanya',
      profession: 'Tech Specialist'
    }
  }, {
    text: 'Мне очень понравилось, я была еще на одном спикинг клабе и у вас мне понравилось, что каждому уделяют внимание то есть каждого отдельно спросят, тема тоже крутая и из за этого лексика улучшается пополняется более сложными словами и очень интересные участники видимо тк это клуб от блога по ит английскому и интересно пообщаться со специалистами из других областей и с теми у кого такая же цель и уровень англ участников тоже классный все быстро говорят записывала себе классные слова и выражения которые девочки использовали и здоров что полтора часа, сначала казалось много но очень быстро пролетело из улучшений мне наверное хотелось бы чтобы перед уроком или на уроке был какой то новый vocabulary чтобы учить новые выражения и практиковать сразу в общем все супер, хочу дальше ходить)',
    author: {
      name: 'Anastasya',
      profession: 'Tech Specialist'
    }
  }]
}];